/* eslint-disable @typescript-eslint/no-explicit-any */
// Tipagem global: informa ao TS que `window.fbq` pode existir
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

/**
 * Injeta o script oficial do Facebook (fbevents.js) uma única vez.
 */
function injectFacebookPixelScript(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  if (typeof window.fbq === 'function') {
    return;
  }

  (function (
    f: Window,
    b: Document,
    e: string,
    v: string,
    n?: any,
    t?: HTMLScriptElement,
    s?: HTMLScriptElement
  ) {
    if ((f as any).fbq) return;
    n = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod(...args);
      } else {
        n.queue.push(args);
      }
    };
    n.queue = [];
    n.loaded = true;
    n.version = '2.0';
    (f as any).fbq = n;

    t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;

    s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
    s.parentNode?.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
}

/**
 * Inicializa um ou vários Facebook Pixels na mesma página.
 * Injeta o script uma vez; para cada ID chama `init`; em seguida um único `PageView` para todos.
 */
export function loadFacebookPixels(pixelIds: string[]): void {
  const ids = pixelIds.filter(
    pixelId => typeof pixelId === 'string' && pixelId.length > 0
  );
  if (!ids.length) {
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.warn('[GomarkePixel] Ambiente inválido para Facebook Pixel');
    return;
  }

  injectFacebookPixelScript();

  for (const pixelId of ids) {
    (window.fbq as any)?.('init', pixelId);
  }
  (window.fbq as any)?.('track', 'PageView');

  console.debug('[GomarkePixel] Facebook Pixel(s) carregados:', ids.join(', '));
}

/**
 * Carrega o Facebook Pixel de forma assíncrona e idempotente (um ID).
 * Para vários IDs na mesma página, prefira `loadFacebookPixels`.
 */
export async function loadFacebookPixel(pixelId: string): Promise<void> {
  if (!pixelId) {
    console.warn('[GomarkePixel] Pixel ID ausente');
    return;
  }
  loadFacebookPixels([pixelId]);
}
